import { dom, library } from '@fortawesome/fontawesome-svg-core';
import {
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
  faCheckCircle,
  faTimesCircle,
  faPlus,
  faMinus,
  faArrowRight,
  faArrowDown,
  faSearchMinus
} from '@fortawesome/free-solid-svg-icons';
import { faSearch, faChevronRight, faChevronLeft, faSpinner } from '@fortawesome/pro-light-svg-icons';
import { faFacebookF, faTwitter, faYoutube, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
library.add(
  faPhone,
  faArrowRight,
  faArrowDown,
  faEnvelope,
  faMapMarkerAlt,
  faSearch,
  faChevronRight,
  faChevronLeft,
  faFacebookF,
  faTwitter,
  faYoutube,
  faLinkedinIn,
  faSpinner,
  faCheckCircle,
  faTimesCircle,
  faPlus,
  faMinus,
  faSearchMinus
);
dom.i2svg();

import 'select2';
import 'slick-carousel';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/tab';
import LazyLoad from 'vanilla-lazyload';
import $ from 'jquery';
require('fslightbox');

/* scroll with hash in url */
if (window.location.hash) {
  var hash = window.location.hash;

  if ($(hash).length) {
    $('html, body').animate(
      {
        scrollTop: $(hash).offset().top
      },
      900,
      'swing'
    );
  }
}

// LazyLoad
let lazyLoadInstance = new LazyLoad({
  elements_selector: '.lazy'
});
lazyLoadInstance.update();

// Jivochat
var invitationSent = false;

const appendPepidrive = function () {
  $('head').append(
    '<script>window.pipedriveLeadboosterConfig = {base: "leadbooster-chat.pipedrive.com",companyId: 4392513,playbookUuid: "f42f56cd-7a3c-4f24-b257-4fd97c6fb9b7",version: 2};(function () {var w = window;if (w.LeadBooster) {console.warn("LeadBooster already exists");} else {w.LeadBooster = {q: [],on: function (n, h) {this.q.push({ t: "o", n: n, h: h });},trigger: function (n) {this.q.push({ t: "t", n: n });},};}})();</script><script src="https://leadbooster-chat.pipedrive.com/assets/loader.js" async></script>'
  );
  //cargar el evento de LeadBooster despues de que se haya cargado el script
  setTimeout(function () {
    try {
      // Pipedrive Lead Booster
      LeadBooster.on('conversationEnded', function (data) {
        if (data.qualified) {
          try {
            gtag('event', 'lead_calificado_pipedrive', {
              event_category: 'pipedrive lead calificado',
              event_label: 'qualified'
            });
            // console.log("pipedrive lead calificado")
          } catch (error) {
            console.log(error);
          }
        } else {
          try {
            gtag('event', 'submit', {
              event_category: 'pipedrive lead no calificado',
              event_label: 'no_qualified'
            });
            //console.log("pipedrive lead no calificado")
          } catch (error) {
            console.log(error);
          }
        }
      });
    } catch (error) {
      console.log('Leadbooster not active');
    }
  }, 2000);
};
const chechStatusJivo = function () {
  var status = jivo_api.chatMode();
  if (status === 'offline') {
    appendPepidrive();
  } else {
    //console.log("First try");
    console.log(status);
  }
};

setTimeout(function () {
  try {
    if (jivo_api !== undefined) {
      chechStatusJivo();
    } else {
      appendPepidrive();
    }
  } catch {
    setTimeout(function () {
      if (jivo_api !== undefined) {
        chechStatusJivo();
      } else {
        appendPepidrive();
      }
    }, 2000);
  }
}, 3000);

function openChat(status, msg) {
  if (status === 'online' && !invitationSent) {
    jivo_api.showProactiveInvitation(msg);
    invitationSent = true;
  } else {
    jivo_api.open();
  }
}

window.addEventListener('DOMContentLoaded', function () {
  // get all anchor tags with class "dataChat"
  const dataChatLinks = document.querySelectorAll('a.dataChat');

  // loop through all the dataChatLinks and add the attribute "data-chat" with value "open"
  dataChatLinks.forEach((link) => {
    link.setAttribute('data-chat', 'open');
  });

  $('[data-chat="open"]').click(function (e) {
    e.preventDefault();
    let msg = $(this).data('message') ? $(this).data('message') : 'Bienvenido, ¿en qué puedo ayudarle?';
    console.log(msg);
    openChat(jivo_api.chatMode(), msg);
    console.log(jivo_api.chatMode());
    try {
      LeadBooster.trigger('open');
    } catch (error) {
      console.log('Leadbooster not active');
    }
  });
});

// Components
import './components/components';
import Accordion from './components/_accordion-custom';

window.addEventListener('DOMContentLoaded', function () {
  const accordions = Array.from(document.querySelectorAll('.accordion-submenu-container'));
  new Accordion(accordions, {
    onOpen: (currElement) => {
      const color = currElement.dataset.color;
      const header = currElement.querySelector('button');
      header.style.color = color;
      header.style.setProperty('--pseudo-element-color', color);
    },
    onClose: (currElement) => {
      const color = '#6d7f8f';
      const header = currElement.querySelector('button');
      header.style.color = color;
      header.style.setProperty('--pseudo-element-color', color);
    }
  });
});

//Frreeform
import { validationForm } from './_utilFreeform';
const getFormByFreeform = function () {
  const excludedHandles = ['newsletter', 'capitalHuman', 'suscripcionEventos', 'disenaTuSolvente'];

  const forms = document.querySelectorAll('[data-freeform ]');
  forms.forEach((freeform) => {
    const handle = freeform.getAttribute('data-handle');
    const emailField = freeform.querySelector('input[type="email"]');

    if (excludedHandles.includes(handle) && !emailField) return;

    emailField.addEventListener('blur', function () {
      const isValid = validationForm(emailField);
      const submitButton = freeform.querySelector('button[type="submit"]');
      if (!isValid) {
        return (submitButton.disabled = true);
      }
      return (submitButton.disabled = false);
    });

    freeform.addEventListener('freeform-on-submit', function (event) {
      if (emailField.value) {
        const isValid = validationForm(emailField);
        if (!isValid) return event.preventDefault();
      }
    });
  });
};

getFormByFreeform();
